
import { useContext, useRef } from "react";

import { findViewById } from "../../lib/helper";

import { AnswerProvider } from "../../state/answers";

import { ViewContext } from "../../state/view";

import { Access } from "../features/access/page";

import { Phase } from "../features/phase/page";

import { Results } from "../features/results/page";

import { Share } from "../features/share/page";

import { Card, CardContent, CardHeader, CardTitle } from "../../components/card";

export function App() {

  const cardRef = useRef( null );

  const { view } = useContext( ViewContext );

  const { label } = findViewById( view );

  return (

    <>

      <Card>

        <CardHeader>

          <CardTitle>{ label }</CardTitle>

        </CardHeader>

        <CardContent ref={ cardRef }>

          <AnswerProvider>

            { view <= 3 && <Phase cardRef={ cardRef } /> }

            { view === 4 && <Access /> }

            { view === 5 && <Results /> }

          </AnswerProvider>

        </CardContent>

      </Card>

    </>

  )

}
